const BOOKISH_ROOT_HOST = "bookishcircle.com";

export const getSafeReaderReturnTo = (returnTo) => {
  if (typeof returnTo !== 'string' || !returnTo) return "";

  const hasUnsafePathCharacters = Array.from(returnTo).some(
    (character) => character === "\\" || character.charCodeAt(0) <= 32
  );
  if (returnTo.startsWith("/") && !returnTo.startsWith("//") && !hasUnsafePathCharacters) {
    return returnTo;
  }

  try {
    const parsed = new URL(returnTo);
    const host = parsed.hostname.toLowerCase();
    const isBookishHost =
      host === BOOKISH_ROOT_HOST || host.endsWith(`.${BOOKISH_ROOT_HOST}`);

    if (parsed.protocol === "https:" && isBookishHost && !parsed.username && !parsed.password && !parsed.port && !hasUnsafePathCharacters) {
      return parsed.href;
    }
  } catch {
    // Invalid and untrusted return URLs fall back to the Reader Portal.
  }

  return "";
};

export const getReaderReturnNavigation = (returnTo, currentOrigin) => {
  const target = getSafeReaderReturnTo(returnTo) || "/readerportal/mainpage";

  if (!target.startsWith("https://")) {
    return { target, isCrossOrigin: false };
  }

  const parsed = new URL(target);
  if (parsed.origin !== currentOrigin) {
    return { target, isCrossOrigin: true };
  }

  return {
    target: `${parsed.pathname || "/"}${parsed.search}${parsed.hash}`,
    isCrossOrigin: false,
  };
};
